__turbopack_context__.v({
  "contactheader": "two-year-upsc-program-module__4JetwW__contactheader",
  "heading3d": "two-year-upsc-program-module__4JetwW__heading3d",
  "invalidCheck2": "two-year-upsc-program-module__4JetwW__invalidCheck2",
  "mbtableheading": "two-year-upsc-program-module__4JetwW__mbtableheading",
  "normalbutton": "two-year-upsc-program-module__4JetwW__normalbutton",
  "pagemaintitle": "two-year-upsc-program-module__4JetwW__pagemaintitle",
  "paybill": "two-year-upsc-program-module__4JetwW__paybill",
  "sectionredtitle": "two-year-upsc-program-module__4JetwW__sectionredtitle",
  "sectiontitle": "two-year-upsc-program-module__4JetwW__sectiontitle",
  "tableheading": "two-year-upsc-program-module__4JetwW__tableheading",
  "tablepara": "two-year-upsc-program-module__4JetwW__tablepara",
  "tablescroll": "two-year-upsc-program-module__4JetwW__tablescroll",
});
